import { render } from "./IssueSidebar.vue?vue&type=template&id=ddd04fde&scoped=true"
import script from "./IssueSidebar.vue?vue&type=script&lang=js"
export * from "./IssueSidebar.vue?vue&type=script&lang=js"

import "./IssueSidebar.vue?vue&type=style&index=0&id=ddd04fde&scoped=true&lang=css"

import exportComponent from "/Users/shanbhad/Documents/BitBucket/storyfinder2_ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd04fde"]])

export default __exports__